
import store from '@/store';
import { SET_TIP_PERCENTAGE } from '@/store/mutations';
import { defineComponent } from 'vue';
import PercentageButton from './PercentageButton.vue';
export default defineComponent({
  name: 'the-calculator-percentage-panel',
  components: { PercentageButton },
  data() {
    return {
      currentPercentage: 0,
      customPercentage: '',
      disabledButtons: false,
      unwatch: () => {
        return;
      },
    };
  },
  watch: {
    customPercentage() {
      if (
        typeof this.customPercentage !== 'string' &&
        this.customPercentage > 0
      ) {
        this.disabledButtons = true;
        this.currentPercentage = 0;
        store.commit(SET_TIP_PERCENTAGE, { value: this.customPercentage });
      } else {
        this.disabledButtons = false;
      }
    },
    currentPercentage() {
      store.commit(SET_TIP_PERCENTAGE, { value: this.currentPercentage });
    },
  },
  created() {
    this.unwatch = this.$store.watch(
      (state, getters) => getters.isStateEmpty,
      (newValue) => {
        if (newValue) {
          this.currentPercentage = 0;
          this.disabledButtons = false;
        }
      },
    );
  },
  beforeUnmount() {
    this.unwatch();
  },
});
